import { StandingOrderFormController } from './standingOrderForm.controller';
import template from './standingOrderForm.html';

export const standingOrderFormComponent = {
  name: 'standingOrderComponent',
  restrict: 'E',
  template,
  controller: StandingOrderFormController,
  controllerAs: 'vm',
  bindings: {
    model: '=',
    labelPrefix: '@',
    isReadonly: '<?',
    copyToClipboard: '<?',
    form: '=',
    category: '<?',
  },
};
